import React, { memo } from 'react';
import DOMPurify from 'dompurify';

type SantizedHTMLProps = {
  html: string;
  allowedTags?: Array<string>;
  className?: string;
};

const SantizedHTML = memo(
  ({ html, allowedTags = ['p', 'strong', 'a', 'br'], className }: SantizedHTMLProps): JSX.Element => {
    const sanitizedHtml = DOMPurify.sanitize(html, {
      ALLOWED_TAGS: allowedTags,
    });

    return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
  }
);

export default SantizedHTML;
